// @flow

import { transport } from "mmb/services/bookings/bookingsApi"
import mapperBookingRefundApplications from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingRefund/services/mapperBookingRefundApplications"
import mapperAssistedRefund from "mmb/scenes/AccountBooking/components/Booking/services/mapper/services/mapperAssistedRefund"
import type { BookingId } from "mmb/types/primitiveTypes"
import type {
  RefundApplication,
  RefundApplicationPayload,
} from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingRefund/consts/refundConsts"
import type { CalculatorPayload } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingRefund/components/BookingRefundCalculator/records/RefundOption"

export const cancelBooking = (bid: BookingId, payload: CalculatorPayload) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/cancellations`, null, payload)

export const getCalculatorData = (bid: BookingId) =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/cancellations`)

export const getRefundApplications = (bid: BookingId): Promise<Array<RefundApplication>> =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/refund_applications`).then(res =>
    res.refund_applications.map(application => mapperBookingRefundApplications(application)),
  )

export const postRefundApplication = (bid: BookingId, payload: RefundApplicationPayload) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/refund_applications`, null, payload)

export const postAssistedRefund = (bid: BookingId, payload: any) =>
  transport("POST", bid, `/mmb/v1/bookings/${bid}/assisted_refund`, null, payload)

export const getAssistedRefundPrice = (bid: BookingId, currency: string) =>
  transport("GET", bid, `/mmb/v1/bookings/${bid}/assisted_refund/price/`, { currency }).then(res =>
    mapperAssistedRefund(res),
  )
